import styles from './SolutionsPage.module.scss';

const SolutionsPage = () => {
  return <div className={styles.wrapper}></div>;
};

// eslint-disable-next-line import/no-default-export
export default SolutionsPage;
